import {
  SET_QUICK_VIEW,
  UPDATE_QUICK_VIEW_TEMPLATE_ID,
} from '../constants/QuickViewConstants';

export const setQuickView = (payload: boolean) => ({
  type: SET_QUICK_VIEW,
  payload,
});

export const updateQuickViewTemplateId = (templateId: string | null) => ({
  type: UPDATE_QUICK_VIEW_TEMPLATE_ID,
  payload: templateId,
});
